import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";

const styles = makeStyles(() => ({
  uploadModal: {
    maxWidth: "520px",
  },
  text: {
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "21px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    color: "#465869",
  },
  button: {
    border: "1px dashed #CCDEEE",
    borderRadius: "8px",
    padding: "25px 16px",
  },
  textButton: {
    fontFamily: "Manrope",
    fontWeight: 700,
    fontSize: "16px",
    lineHeight: "24px",
    color: colors.brandBlue500,
  },
  textButtonFormat: {
    fontFamily: "Manrope",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "24px",
    color: colors.gray500,
  },
  textButtonInfo: {
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "21px",
    color: colors.gray500,
  },
  filename: {
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "24px",
    color: "#667085",
    marginLeft: "12px",
  },
  redColor: {
    color: "#F97066",
  },
  dropzone: {
    cursor: "pointer",
  },
  showFile: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: "#FCFCFD",
    borderRadius: "12px",
    paddingLeft: "16px",
  },
  showFileLeft: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  loadingMainDiv: {
    width: "100%",
    display: "flex !important",
    justifyContent: "center !important",
    alignItems: "center !important",
  },
  loadingContainer: {
    display: "flex",
    width: "80%",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    gap: "40px",
    alignSelf: "center",
  },
  loadingTitle: {
    fontFamily: "Manrope",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "20px",
    color: "#308CDB",
    textAlign: "center",
  },
  loadingProgress: {
    width: "25% !important",
    height: "100% !important",
    color: "#308CDB",
  },

  errorTitle: {
    color: colors.gray600,
    fontFamily: "Manrope",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    letterSpacing: "0.5px",
    lineHeight: "24px",
  },
  errorLine: {
    color: colors.error600,
    fontFamily: "Manrope",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    letterSpacing: "0.5px",
    lineHeight: "24px",
  },

  downloadTemplate: {
    height: "32px",
    backgroundColor: "#F2F4F7",
    borderRadius: "8px",
    "&:hover": {
      backgroundColor: "#F2F4F7",
      borderColor: "transparent",
    },
    "& span": {
      color: "#308CDB",
      fontSize: "12px",
      fontWeight: 700,
      fontFamily: "Inter",
    },
  },
}));

export default styles;
